function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 164 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 374",
    d: "M14 0A14 14 0 1 1 0 14 14 14 0 0 1 14 0z",
    style: {
      fill: "#4cb71a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined Shape",
    d: "M0 5.377V1.2a1.195 1.195 0 1 1 2.39 0v2.937h10.171a1.195 1.195 0 1 1 0 2.39H1.521A1.2 1.2 0 0 1 0 5.377z",
    transform: "rotate(-40 22.29 -2.184)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepDone);
export default __webpack_public_path__ + "static/media/step-done.60699f32889fd8fd5640757e08519c6f.svg";
export { ForwardRef as ReactComponent };